import { render } from "./ProfileButton.vue?vue&type=template&id=4a88a420&ts=true"
import script from "./ProfileButton.vue?vue&type=script&lang=ts"
export * from "./ProfileButton.vue?vue&type=script&lang=ts"

import "./ProfileButton.vue?vue&type=style&index=0&id=4a88a420&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__